module.exports = __webpack_public_path__ + "static/media/19ESCAP43.4d85d431.jpg";